import React, {useContext} from 'react';
import { useParams } from 'react-router-dom';

// Hooks
import useFetchSeriesDetails from "../../../../Hooks/Content/Watch/Series/useFetchSeriesDetails";

// Components
import SeriesHero from '../../../../Components/Layouts/Content/Watch/Series/SeriesHero';
import SeasonSelector from "../../../../Components/Layouts/Content/Watch/Series/SeasonSelector";

// Context
import {GlobalInterfaceContext} from "../../../../Context/GlobalInterfaceContext";
import {UserAuthenticationContext} from "../../../../Context/UserAuthenticationContext";

const SeriesSingle = () => {
    const
        { id } = useParams<{ id: string }>(),
        numericId = id ? parseInt(id, 10) : undefined,

        { isDarkMode } = useContext(GlobalInterfaceContext),
        { userData } = useContext(UserAuthenticationContext),

        { series, loading, error } = useFetchSeriesDetails(numericId, 0);

    return (
        <div id={`series-${series.Id}`} className={`page page--series-single ${isDarkMode ? 'is-dark-mode' : 'is-light-mode'}`}>
            <SeriesHero
                title={series.Title ?? undefined}
                description={series.Description ?? undefined}
                background={series.BackgroundImage ?? undefined}
                userData={userData}
                seriesId={series.Id}
                trailerLink={series.TrailerLink ?? undefined}
            />

            <SeasonSelector
                seriesId={series.Id}
                yearly={series.YearlyEpisodeDisplay}
                seriesDatetime={series.Datetime}
                seasonCount={series.SeasonCount}
                isDarkMode={isDarkMode}
            />
        </div>
    )
}

export default SeriesSingle;
